"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var Attachments = function Attachments(props) {
  var className = props.className,
    description = props.description;
  return /*#__PURE__*/_react["default"].createElement(StyledAttachments, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledAttachmentsDescription, {
    dangerouslySetInnerHTML: {
      __html: description !== null && description !== void 0 ? description : ''
    }
  }));
};
var StyledAttachments = _styledComponents["default"].div.withConfig({
  displayName: "Attachments__StyledAttachments",
  componentId: "sc-36pf46-0"
})(["padding:8px 16px;"]);
var StyledAttachmentsDescription = _styledComponents["default"].div.withConfig({
  displayName: "Attachments__StyledAttachmentsDescription",
  componentId: "sc-36pf46-1"
})(["font-size:14px;line-height:16px;margin-bottom:10px;color:", ";"], _userflow["default"].colors.blackBase);
var _default = exports["default"] = Attachments;